import { IVendorPayoffInformationData } from '../../../types/vendorDashboard/IVendorPayoffInformation';
import { createDefaultFetch, IFetchStatus } from 'types/rest/IFetchStatus';

export interface IVendorPayoffState {
  payoff: { [orderId: string]: IVendorPayoffInformationData };
  payoffFetchStatus: IFetchStatus;
  payoffError?: string;
  updatePayoffFetchStatus: IFetchStatus;
  updatePayoffError?: string;
  sentToSpruceFetchStatus: IFetchStatus;
  sentToSpruceError?: string;
}

export const vendorPayoffInitialState: IVendorPayoffState = {
  payoff: {},
  payoffFetchStatus: createDefaultFetch(),
  updatePayoffFetchStatus: createDefaultFetch(),
  sentToSpruceFetchStatus: createDefaultFetch(),
};
